/**
 * Runtime host detection.
 *
 * The same React build serves app.intrlock.io and admin.intrlock.io. Some
 * surfaces (dollar figures: monthly revenue, open balances, premium-feature
 * pricing) should only be visible on the admin surface and hidden on the
 * customer-facing app. Use `isAdminHost()` to gate those views.
 */
export const isAdminHost = (): boolean => {
  if (typeof window === 'undefined') return false;
  return window.location.hostname.startsWith('admin.')
    || window.location.hostname.startsWith('shadow.admin.');
};
